// Port of api/fuel/app/classes/filter/activity.php
import Filter from 'offline/filter/core/filter'
import F from 'offline/filter/constants'
import Constants from 'offline/constants'
import HindexType from 'offline/model/hindex/type'
import User from 'offline/model/user'
import Game from 'offline/model/game'
import CollectionLog from 'offline/model/log/user/collection'
import CollectionStatusLog from 'offline/model/log/user/collection/status'
import CommentLog from 'offline/model/log/user/comment'
import EditionLog from 'offline/model/log/user/edition'
import HindexLog from 'offline/model/log/user/hindex'
import ListingLog from 'offline/model/log/user/listing'
import MemberLog from 'offline/model/log/user/member'
import BuddyLog from 'offline/model/log/user/buddy'
import BuddiesLog from 'offline/model/log/user/buddies'
import PlayLog from 'offline/model/log/user/play'
import RatingLog from 'offline/model/log/user/rating'
import GroupLog from 'offline/model/log/user/group'
import InitiatedLog from 'offline/model/log/user/initiated'
import RegisteredLog from 'offline/model/log/user/registered'
import TagLog from 'offline/model/log/user/tag'
import TagAttachLog from 'offline/model/log/user/tag/attach'

var DESCRIPTORS = [
	{ type: Constants.LOG_TYPE_USER_PLAY, key: 'play', model: PlayLog, owner: 'users' },
	{ type: Constants.LOG_TYPE_USER_COLLECTION, key: 'collection', model: CollectionLog, owner: 'users' },
	{ type: Constants.LOG_TYPE_USER_RATING, key: 'rating', model: RatingLog, owner: 'users' },
	{ type: Constants.LOG_TYPE_USER_HINDEX, key: 'hindex', model: HindexLog, owner: 'users' },
	{ type: Constants.LOG_TYPE_USER_COMMENT, key: 'comment', model: CommentLog, owner: 'users' },
	{ type: Constants.LOG_TYPE_USER_COLLECTION_STATUS, key: 'status', model: CollectionStatusLog, owner: 'users' },
	{ type: Constants.LOG_TYPE_USER_EDITION, key: 'edition', model: EditionLog, owner: 'owner' },
	{ type: Constants.LOG_TYPE_USER_LIST, key: 'list', model: ListingLog, owner: 'owner' },
	{ type: Constants.LOG_TYPE_USER_MEMBER, key: 'member', model: MemberLog, owner: 'group' },
	{ type: Constants.LOG_TYPE_USER_BUDDY, key: 'buddy', model: BuddyLog, owner: 'buddies' },
	{ type: Constants.LOG_TYPE_USER_INITIATED, key: 'initiated', model: InitiatedLog, owner: 'user-only' },
	{ type: Constants.LOG_TYPE_USER_REGISTERED, key: 'registered', model: RegisteredLog, owner: 'user-only' },
	{ type: Constants.LOG_TYPE_USER_BUDDIES, key: 'buddies', model: BuddiesLog, owner: 'buddies' },
	{ type: Constants.LOG_TYPE_USER_GROUP, key: 'group', model: GroupLog, owner: 'group' },
	{ type: Constants.LOG_TYPE_USER_TAG, key: 'tag', model: TagLog, owner: 'users' },
	{ type: Constants.LOG_TYPE_USER_TAG_ATTACH, key: 'tag-attach', model: TagAttachLog, owner: 'users' }
]

var MODELS = {}

for (var i = 0; i < DESCRIPTORS.length; i++) {
	MODELS[DESCRIPTORS[i].key] = DESCRIPTORS[i].model
}

function isOwnerType(config, ownerType) {
	return config.ownerType === ownerType
}

function cloneWhere(filter, config) {
	var where = [['log_initial_sync', '<>', 1]]

	if (filter.date.from) where.push(['log_date', '>=', filter.date.from])
	if (filter.date.to) where.push(['log_date', '<=', filter.date.to])
	if (filter.members.length) where.push(['user_id', 'in', filter.members])

	if (isOwnerType(config, F.OWNER_BUDDIES) || isOwnerType(config, F.OWNER_GROUP)) {
		where.push(['log_date', '>=', config.owner.get_date_created()])
	}

	return where
}

function ignoredStatuses(filter) {
	var hidden = []
	var statusMap = {
		own: Constants.COLLECTION_STATUS_OWN,
		prevowned: Constants.COLLECTION_STATUS_PREVOWNED,
		fortrade: Constants.COLLECTION_STATUS_FORTRADE,
		want: Constants.COLLECTION_STATUS_WANT,
		wanttoplay: Constants.COLLECTION_STATUS_WANTTOPLAY,
		wanttobuy: Constants.COLLECTION_STATUS_WANTTOBUY,
		wishlist: Constants.COLLECTION_STATUS_WISHLIST,
		preordered: Constants.COLLECTION_STATUS_PREORDERED,
		hasparts: Constants.COLLECTION_STATUS_HASPARTS,
		wantparts: Constants.COLLECTION_STATUS_WANTPARTS
	}
	var keys = Object.keys(statusMap)

	for (var i = 0; i < keys.length; i++) {
		if (filter.hide.status[keys[i]]) hidden.push(statusMap[keys[i]])
	}

	return hidden
}

function applicable(filter) {
	var map = {}

	for (var i = 0; i < DESCRIPTORS.length; i++) map[DESCRIPTORS[i].type] = true

	if (filter.hide.edition.added) map[Constants.LOG_TYPE_USER_EDITION] = []
	if (filter.hide.play.added) map[Constants.LOG_TYPE_USER_PLAY] = []

	if (filter.hide.status.added || filter.hide.status.removed) map[Constants.LOG_TYPE_USER_COLLECTION_STATUS] = []
	if (filter.hide.list.added || filter.hide.list.removed) map[Constants.LOG_TYPE_USER_LIST] = []
	if (filter.hide.member.added || filter.hide.member.removed) map[Constants.LOG_TYPE_USER_MEMBER] = []
	if (filter.hide.buddy.added || filter.hide.buddy.removed) map[Constants.LOG_TYPE_USER_BUDDY] = []
	if (filter.hide.rating.added || filter.hide.rating.updated || filter.hide.rating.removed) map[Constants.LOG_TYPE_USER_RATING] = []
	if (filter.hide.comment.added || filter.hide.comment.updated || filter.hide.comment.removed) map[Constants.LOG_TYPE_USER_COMMENT] = []
	if (filter.hide.collection.added || filter.hide.collection.removed) map[Constants.LOG_TYPE_USER_COLLECTION] = []
	if (filter.hide.tags.created || filter.hide.tags.deleted) map[Constants.LOG_TYPE_USER_TAG] = []
	if (filter.hide.tags.added || filter.hide.tags.removed) map[Constants.LOG_TYPE_USER_TAG_ATTACH] = []

	if (filter.hide.edition.added) map[Constants.LOG_TYPE_USER_EDITION].push(Constants.LOG_CONTEXT_ADDED)

	if (filter.hide.list.added) map[Constants.LOG_TYPE_USER_LIST].push(Constants.LOG_CONTEXT_ADDED)
	if (filter.hide.list.removed) map[Constants.LOG_TYPE_USER_LIST].push(Constants.LOG_CONTEXT_REMOVED)

	if (filter.hide.status.added) map[Constants.LOG_TYPE_USER_COLLECTION_STATUS].push(Constants.LOG_CONTEXT_ADDED)
	if (filter.hide.status.removed) map[Constants.LOG_TYPE_USER_COLLECTION_STATUS].push(Constants.LOG_CONTEXT_REMOVED)

	if (filter.hide.member.added) map[Constants.LOG_TYPE_USER_MEMBER].push(Constants.LOG_CONTEXT_ADDED)
	if (filter.hide.member.removed) map[Constants.LOG_TYPE_USER_MEMBER].push(Constants.LOG_CONTEXT_REMOVED)

	if (filter.hide.buddy.added) map[Constants.LOG_TYPE_USER_BUDDY].push(Constants.LOG_CONTEXT_ADDED)
	if (filter.hide.buddy.removed) map[Constants.LOG_TYPE_USER_BUDDY].push(Constants.LOG_CONTEXT_REMOVED)

	if (filter.hide.rating.added) map[Constants.LOG_TYPE_USER_RATING].push(Constants.LOG_CONTEXT_ADDED)
	if (filter.hide.rating.updated) map[Constants.LOG_TYPE_USER_RATING].push(Constants.LOG_CONTEXT_UPDATED)
	if (filter.hide.rating.removed) map[Constants.LOG_TYPE_USER_RATING].push(Constants.LOG_CONTEXT_REMOVED)

	if (filter.hide.comment.added) map[Constants.LOG_TYPE_USER_COMMENT].push(Constants.LOG_CONTEXT_ADDED)
	if (filter.hide.comment.updated) map[Constants.LOG_TYPE_USER_COMMENT].push(Constants.LOG_CONTEXT_UPDATED)
	if (filter.hide.comment.removed) map[Constants.LOG_TYPE_USER_COMMENT].push(Constants.LOG_CONTEXT_REMOVED)

	if (filter.hide.collection.added) map[Constants.LOG_TYPE_USER_COLLECTION].push(Constants.LOG_CONTEXT_ADDED)
	if (filter.hide.collection.removed) map[Constants.LOG_TYPE_USER_COLLECTION].push(Constants.LOG_CONTEXT_REMOVED)

	if (filter.hide.tags.created) map[Constants.LOG_TYPE_USER_TAG].push(Constants.LOG_CONTEXT_CREATED)
	if (filter.hide.tags.deleted) map[Constants.LOG_TYPE_USER_TAG].push(Constants.LOG_CONTEXT_DELETED)

	if (filter.hide.tags.added) map[Constants.LOG_TYPE_USER_TAG_ATTACH].push(Constants.LOG_CONTEXT_ADDED)
	if (filter.hide.tags.removed) map[Constants.LOG_TYPE_USER_TAG_ATTACH].push(Constants.LOG_CONTEXT_REMOVED)

	if (filter.hide.play.added) map[Constants.LOG_TYPE_USER_PLAY].push(Constants.LOG_CONTEXT_ADDED)

	if (filter.hide.hindex) map[Constants.LOG_TYPE_USER_HINDEX] = false

	return map
}

function descriptorWhere(descriptor, config, filter) {
	var where = cloneWhere(filter, config)
	var ignored = applicable(filter)[descriptor.type]

	if (Array.isArray(ignored)) where.push(['log_context', 'not in', ignored])

	if (descriptor.owner === 'users') {
		where.push(['user_id', 'in', config.users])
	} else if (descriptor.owner === 'user-only') {
		if (!isOwnerType(config, F.OWNER_USER)) return false
		where.push(['user_id', 'in', config.users])
	} else if (descriptor.owner === 'group') {
		if (!isOwnerType(config, F.OWNER_GROUP)) return false
		where.push(['group_id', '=', config.owner.get_id()])
	} else if (descriptor.owner === 'buddies') {
		if (!isOwnerType(config, F.OWNER_BUDDIES)) return false
		where.push(['buddies_id', '=', config.owner.get_id()])
	} else if (descriptor.owner === 'owner') {
		if (isOwnerType(config, F.OWNER_USER)) where.push(['user_id', '=', config.owner.get_id()])
		if (isOwnerType(config, F.OWNER_GROUP)) where.push(['group_id', '=', config.owner.get_id()])
		if (isOwnerType(config, F.OWNER_BUDDIES)) where.push(['buddies_id', '=', config.owner.get_id()])
	}

	if (descriptor.type === Constants.LOG_TYPE_USER_COLLECTION_STATUS) {
		var hiddenStatuses = ignoredStatuses(filter)
		if (hiddenStatuses.length) where.push(['log_status', 'not in', hiddenStatuses])
	}

	return where
}

var Activity = Filter.extend({
	filter_type: F.TYPE_ACTIVITIES,
	cache_type: F.CACHE_ACTIVITY,
	result_type: F.RESULT_ACTIVITY,
	pseudo_type: F.PSEUDO_ACTIVITY,
	json_package: 'activity',
	package_types: [F.PACKAGE_LIST],
	search: function(data) {
		var filter = this._filter
		var config = this._config
		var enabled = applicable(filter)
		var candidates = []

		for (var i = 0; i < DESCRIPTORS.length; i++) {
			var descriptor = DESCRIPTORS[i]
			if (!enabled[descriptor.type]) continue

			var where = descriptorWhere(descriptor, config, filter)
			if (!where) continue

			var logs = descriptor.model.filter({
				arrayed: true,
				select: {
					rename: {
						log_id: 'id',
						log_date: 'date'
					}
				},
				where: where,
				order: {
					log_date: 'desc'
				}
			})

			for (var j = 0; j < logs.length; j++) {
				candidates.push({
					id: logs[j].id,
					date: logs[j].date,
					key: descriptor.key
				})
			}
		}

		candidates.sort(function(a, b) {
			return parseInt(b.date || 0, 10) - parseInt(a.date || 0, 10)
		})

		data.results = candidates.map(function(candidate) {
			return candidate.key + '|' + candidate.id
		})
		data.total = data.results.length
		data.nested = []
		data.pseudo = data.results.length
		data.maximum = data.results.length

		return data
	},
	package: function(data) {
		var activity = []

		for (var i = 0; i < data.results.length; i++) {
			var parts = data.results[i].split('|')
			var Model = MODELS[parts[0]]
			var item = Model ? Model.with_id(parts[1]) : null

			if (item) activity.push(item.to_array())
		}

		return [activity, data]
	},
	data: function() {
		var data = {
			games: [],
			users: [],
			hindexes: []
		}
		var gameIds = []
		var userIds = []
		var hindexIds = []

		for (var i = 0; i < this._package.length; i++) {
			if (this._package[i].game) gameIds.push(this._package[i].game)
			if (this._package[i].user) userIds.push(this._package[i].user)
			if (this._package[i].hindextype) hindexIds.push(this._package[i].hindextype)
		}

		gameIds = gameIds.filter(function(id, index) { return id && gameIds.indexOf(id) === index })
		userIds = userIds.filter(function(id, index) { return id && userIds.indexOf(id) === index })
		hindexIds = hindexIds.filter(function(id, index) { return id && hindexIds.indexOf(id) === index })

		if (hindexIds.length) {
			HindexType.where([['hindex_id', 'in', hindexIds]]).forEach(function(hindex) {
				data.hindexes.push(hindex.to_public())
			})
		}

		if (gameIds.length) {
			Game.where([['game_id', 'in', gameIds]]).forEach(function(game) {
				data.games.push(game.to_array(true))
			})
		}

		if (userIds.length) {
			User.where([['user_id', 'in', userIds]]).forEach(function(user) {
				data.users.push(user.to_array(true))
			})
		}

		return data
	}
})

export default Activity
